import type { Availability } from "./api.ts";

export function availabilityLabel(
    availability: Availability,
): string {
    switch (availability) {
        case "in_stock":
            return "Available now";

        case "made_to_order":
            return "Made to order";
    }
}
